fragment ShareThisArticleFragment on shareThisArticle_Entry {
  typeHandle
}
